import { buildSeasonTagWithWildcards } from '../../utils/seasonUtils';
import { LegacyCropsMap } from '../types/LegacyCropsMap';

import { HarvestEvents } from '../../types/Harvest';
import { HarvestYield } from '../../types/HarvestYield';
import { UapiGetHarvestEventAggregatesArdQuery } from '../../graphql/sdk';

type HarvestEventByCropSeason = NonNullable<
  NonNullable<
    NonNullable<UapiGetHarvestEventAggregatesArdQuery['field']>['harvestEventAggregates']
  >['eventsByCropSeason']
>[number];

interface AdaptHarvestEventParams {
  fieldUuid: string;
  legacySeasonTag: string;
  harvestEvent: HarvestEventByCropSeason;
}

function adaptHarvestEvent({
  fieldUuid,
  legacySeasonTag,
  harvestEvent: {
    harvestedArea,
    nominalWeight,
    averageStdYield,
    wetMass,
    dryMass,
    moistureMass,
    moisturePercent,
    crop,
  }
}: AdaptHarvestEventParams): HarvestYield {
  return {
    fieldUuid,
    seasonTag: legacySeasonTag,
    nominalWeight: nominalWeight?.v || null,
    yieldAverage: averageStdYield.u ? {
      q: averageStdYield.v,
      u: averageStdYield.u,
    } : null,
    totalYield: dryMass.u ? {
      q: dryMass.v,
      u: dryMass.u,
    } : null,
    standardisedAverageYield: null,
    mass: {
      wet: wetMass && wetMass.u ? {
        q: wetMass.v,
        u: wetMass.u,
      } : null,
      dry: dryMass && dryMass.u ? {
        q: dryMass.v,
        u: dryMass.u,
      } : null,
      moisture: moistureMass && moistureMass.u ? {
        q: moistureMass.v,
        u: moistureMass.u,
      } : null,
      avgMoisture: moisturePercent && moisturePercent.u ? {
        q: moisturePercent.v,
        u: moisturePercent.u,
      } : null
    },
    area: {
     harvest: harvestedArea.u ? {
        q: harvestedArea.v,
        u: harvestedArea.u,
     } : null
    },
    crop,
  }
}

export function adaptUapiHarvestResponse(
  response: UapiGetHarvestEventAggregatesArdQuery,
  cropsMaps: LegacyCropsMap
): HarvestEvents {
  const defaultResult: HarvestEvents = {
    events: {},
    harvestSeasons: [],
  };

  const eventsByCropSeason = response?.field?.harvestEventAggregates?.eventsByCropSeason || [];

  if(!response.field?.id) {
    return defaultResult;
  }

  const fieldUuid = response.field.id;

  return eventsByCropSeason.reduce((accum, currentHarvestEvent) => {
    const { seasonYear, seasonName, crop } = currentHarvestEvent;

    const legacySeasonCode = buildSeasonTagWithWildcards({
      year: seasonYear,
      season: seasonName,
      cropCode: cropsMaps[crop.id]
    });

    if (!accum.events[legacySeasonCode]) {
      return {
        ...accum,
        events: {
          ...accum.events,
          [legacySeasonCode]: adaptHarvestEvent({
            fieldUuid,
            legacySeasonTag: legacySeasonCode,
            harvestEvent: currentHarvestEvent,
          }),
        },
        harvestSeasons: [
          ...accum.harvestSeasons,
          legacySeasonCode
        ]
      };
    }

    return accum;
  }, defaultResult);
}